@use "../../../../styles/Constants.scss" as Constants;

.imageRow {
	display: flex;
	padding: Constants.$val-spacing-m Constants.$val-spacing-l;
	align-items: center;

	& > * + * {
		margin-left: Constants.$val-spacing-s;
	}
}